import { css } from '@emotion/react';

export const EmojiRightSpace = css`
  margin-right: 0.25em;
`;
